import { render, staticRenderFns } from "./bread_crumb.vue?vue&type=template&id=0bcb33da&scoped=true"
import script from "./bread_crumb.vue?vue&type=script&lang=js"
export * from "./bread_crumb.vue?vue&type=script&lang=js"
import style0 from "./bread_crumb.vue?vue&type=style&index=0&id=0bcb33da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb33da",
  null
  
)

export default component.exports